import _ from 'lodash';
import moment from 'moment';
import axios from 'axios';

export const searchPolicyApi = async (payload) => {
  const values = { ...payload };
  if (_.isEmpty(values?.policyNumber)) {
    _.set(values, 'policyNumber', '');
  }
  if (_.isEmpty(values?.poName)) {
    _.set(values, 'poName', '');
  }
  if (_.isEmpty(values?.reminderType)) {
    _.set(values, 'reminderType', 'PREMIUM_DUE');
  }
  if (values?.fromPremiumDue) {
    _.set(values, 'fromPremiumDue', moment(values?.fromPremiumDue).format('yyyy-MM-DDTHH:mm:ss.SSSZ'));
  }
  if (values?.toPremiumDue) {
    _.set(values, 'toPremiumDue', moment(values?.toPremiumDue).format('yyyy-MM-DDTHH:mm:ss.SSSZ'));
  }
  return axios.post(`/api/bankpolicy/list`, values).then((res) => res.data.content);
};

export const searchMonthlyIssuedApi = async (payload) => {
  const values = { ...payload };
  if (values?.from) {
    _.set(values, 'from', moment(values?.from).format('yyyy-MM-DD'));
  }
  if (values?.to) {
    _.set(values, 'to', moment(values?.to).format('yyyy-MM-DD'));
  }
  return axios.post(`/api/bankpolicy/monthly-issued-list`, values).then((res) => res.data.content);
};